"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Image = _interopRequireDefault(require("../Image"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Tag = _interopRequireDefault(require("../Tag"));
var _CardInfo = _interopRequireDefault(require("./CardInfo.proptypes"));
var _constant = require("./constant");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledMainWrapper = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__StyledMainWrapper",
  componentId: "sc-1j9xfe4-0"
})(["", " padding:", ";", " ", ""], function (_ref) {
  var hasBorder = _ref.hasBorder,
    theme = _ref.theme;
  return hasBorder && "border: 1px solid ".concat(theme.backgroundColor.greyLight, "; border-radius: ").concat(theme.borderRadius.small, ";");
}, function (_ref2) {
  var theme = _ref2.theme,
    hasHeader = _ref2.hasHeader;
  return hasHeader ? theme.space.XSmall : "".concat(theme.space.XSmall, " 0 ").concat(theme.space.XSmall, " ");
}, function (_ref3) {
  var bgColor = _ref3.bgColor,
    theme = _ref3.theme;
  return "background: ".concat(theme.backgroundColor[bgColor], ";");
}, function (_ref4) {
  var hasBoxShadow = _ref4.hasBoxShadow;
  return hasBoxShadow && "box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);";
});
var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__StyledWrapper",
  componentId: "sc-1j9xfe4-1"
})(["display:flex;align-items:center;"]);
var InlineWrapper = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__InlineWrapper",
  componentId: "sc-1j9xfe4-2"
})(["display:flex;align-items:center;gap:4px;"]);
var StyledIconContainer = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__StyledIconContainer",
  componentId: "sc-1j9xfe4-3"
})(["", " ", " ", ""], function (_ref5) {
  var theme = _ref5.theme,
    position = _ref5.position,
    customized = _ref5.customized;
  return position === 'left' ? "margin-right: ".concat(customized ? theme.space.none : theme.space.tiny, ";") : "margin-left: ".concat(theme.space.small, ";");
}, function (_ref6) {
  var customized = _ref6.customized;
  return customized && "filter:opacity(0.5) drop-shadow(0 0 0 gray);";
}, function (_ref7) {
  var titleFirst = _ref7.titleFirst;
  return titleFirst && "align-items:end;";
});
var StyledTextContainer = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__StyledTextContainer",
  componentId: "sc-1j9xfe4-4"
})(["display:flex;flex-direction:column;", " p{display:inline-block !important;}"], function (_ref8) {
  var titleFirst = _ref8.titleFirst;
  return titleFirst && "align-items:flex-start;";
});
var TagContainer = _styledComponents.default.div.withConfig({
  displayName: "CardInfo__TagContainer",
  componentId: "sc-1j9xfe4-5"
})(["display:flex;flex-direction:row;"]);
var CardInfo = function CardInfo(_ref9) {
  var accessible = _ref9.accessible,
    theme = _ref9.theme,
    customProperties = _ref9.customProperties,
    title = _ref9.title,
    titleType = _ref9.titleType,
    content = _ref9.content,
    imgSrc = _ref9.imgSrc,
    imgHeight = _ref9.imgHeight,
    imgWidth = _ref9.imgWidth,
    icon = _ref9.icon,
    iconPosition = _ref9.iconPosition,
    iconSize = _ref9.iconSize,
    iconColor = _ref9.iconColor,
    bgColor = _ref9.bgColor,
    hasBorder = _ref9.hasBorder,
    hasBoxShadow = _ref9.hasBoxShadow,
    titleFirst = _ref9.titleFirst,
    textLimit = _ref9.textLimit,
    hasTextToggle = _ref9.hasTextToggle,
    translation = _ref9.translation,
    hasHeader = _ref9.hasHeader,
    contentAs = _ref9.contentAs,
    tagline = _ref9.tagline,
    isPromoApplied = _ref9.isPromoApplied;
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var renderIcon = function renderIcon(imageIcon) {
    return /*#__PURE__*/_react.default.createElement(StyledIconContainer, {
      position: iconPosition,
      titleFirst: titleFirst,
      customized: !!imageIcon
    }, imgSrc || imageIcon ? /*#__PURE__*/_react.default.createElement(_Image.default, {
      accessible: accessible,
      centerFocus: false,
      placeHolderBackground: "none",
      radius: "0px",
      theme: theme,
      src: imageIcon || imgSrc,
      height: imgHeight,
      width: imgWidth
    }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: iconColor,
      fontsize: iconSize,
      icon: icon,
      theme: theme
    }));
  };
  var hasImgOrIcon = icon || imgSrc;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledMainWrapper, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties, {
    bgColor: bgColor,
    hasBorder: hasBorder,
    hasBoxShadow: hasBoxShadow,
    hasHeader: hasHeader
  }), /*#__PURE__*/_react.default.createElement(StyledWrapper, null, hasImgOrIcon && iconPosition === _constant.ICON_POSITION.left && renderIcon(), /*#__PURE__*/_react.default.createElement(StyledTextContainer, {
    titleFirst: titleFirst
  }, isPromoApplied && /*#__PURE__*/_react.default.createElement(TagContainer, {
    "aria-label": "Included"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    accessible: true,
    backgroundColor: "greenLight",
    borderRadius: "4px",
    color: "tertiary",
    display: "inlineFlex",
    handleOnClick: function handleOnClick() {},
    padding: "1px 4px",
    margin: "0px 0px 2px 0px",
    tag: "div",
    theme: theme,
    type: "small",
    bold: true
  }, /*#__PURE__*/_react.default.createElement(InlineWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "LocalOfferIcon",
    color: "tertiary",
    ontsize: iconSize
  }), " ", language.voucherApplied))), tagline, titleFirst ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: accessible,
    display: _constant.TEXT_PROPS.block,
    theme: theme,
    type: titleType.type,
    bold: true,
    marginBottom: "micro"
  }, titleType.color && {
    color: titleType.color
  }), title), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT_PROPS.block,
    theme: theme,
    type: _constant.TEXT_PROPS.small,
    textLimit: textLimit,
    hasToggle: hasTextToggle,
    translation: language,
    color: _constant.TEXT_PROPS.greyDark,
    as: contentAs
  }, content)) : /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: accessible,
    display: _constant.TEXT_PROPS.inline,
    theme: theme,
    type: titleType.type,
    bold: true
  }, titleType.color && {
    color: titleType.color
  }), title, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant.TEXT_PROPS.inline,
    theme: theme,
    type: _constant.TEXT_PROPS.small,
    textLimit: textLimit,
    hasToggle: hasTextToggle,
    translation: language,
    color: _constant.TEXT_PROPS.greyDark
  }, content))), hasImgOrIcon && iconPosition === _constant.ICON_POSITION.right && renderIcon())));
};
CardInfo.propTypes = _CardInfo.default.PropTypes;
CardInfo.defaultProps = _CardInfo.default.DefaultProps;
var _default = CardInfo;
exports.default = _default;